export default (before, after) => {

  if (before === null) {
    if (after.length > 0) {
      return 'Added'
    } else {
      return null
    }
  }

  if (before.length > after.length) {
    return 'Removed'
  }

  if (before.length < after.length) {
    return 'Added'
  }

  // Number tokens unchanged, so flipped?
  var beforeWhite = before.filter(i=>i.toLowerCase()==='white').length;
  var afterWhite = after.filter(i=>i.toLowerCase()==='white').length;

  if (afterWhite > beforeWhite) {
    return 'Used Black';
  } else {
    return 'Used White';
  }
}


// WEBPACK FOOTER //
// ./src/DestinyContainer/DestinyDiff.js